import { useState } from "react";
import { fetchExcuseDuties } from "../../utils/patients/fetchExcuseDuties";
import { printExcuseDuty } from "../../utils/patients/printExcuseDuty";
import useProfileStore from "../../store/patient/profileStore";

const useManageExcuseDuty = () => {
  const [loading, setLoading] = useState(false);
  const [duties, setDuties] = useState([]);
  const [meta, setMeta] = useState(null);
  const { profile } = useProfileStore();

  const handleFetchExcuseDuties = async (page = 1, limit = 10) => {
    if (!profile?.id) return;
    try {
      setLoading(true);
      const res = await fetchExcuseDuties(profile.id, page, limit);
      const data = res?.data;
      // backend returns { result, totalPages, currentPage, ... }
      if (data?.result) {
        setDuties(data.result);
        setMeta({ currentPage: data.currentPage, totalPages: data.totalPages, itemsPerPage: data.itemsPerPage, lastPage: data.lastPage });
      } else if (Array.isArray(data)) {
        setDuties(data);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      if (err?.response?.status === 401) window.location.href = "/pages/signin2";
    }
  };

  const handlePrintExcuseDuty = async (id) => {
    try {
      const res = await printExcuseDuty(id);
      return res?.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    loading,
    duties,
    meta,
    handleFetchExcuseDuties,
    handlePrintExcuseDuty,
  };
};

export default useManageExcuseDuty;
